import React, { useState, useCallback } from 'react';
import checkIsIntegerNumber from 'common/utils/checkIsIntegerNumber';

export type TextFieldValue = string;
export type handlerChangeTextFieldValue = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => void;
export type HandleChangeTextFieldValue = handlerChangeTextFieldValue;
export type setTextFieldValueValue = React.Dispatch<React.SetStateAction<string>>;
export type SetTextFieldValue = setTextFieldValueValue;
export type resetTextFieldValue = () => void;
type changeCallback = (event: React.ChangeEvent<HTMLInputElement>) => void;
type FieldType = 'text' | 'int';
export interface Settings {
  fieldType?: FieldType;
}

const checkIsFieldTypeText = (fieldType: FieldType) => (fieldType === 'text');
const checkIsFieldTypeNumber = (fieldType: FieldType) => (fieldType === 'int');

export const useTextFieldState = (
  initValue = '',
  changeCallback?: changeCallback,
  settings?: Settings
) => {
  const { fieldType = 'text' } = settings || {};
  const [value, setValue] = useState<TextFieldValue>(() => initValue);

  const handlerChangeValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { target: { value } } = event;
    if (
      checkIsFieldTypeText(fieldType)
      || (checkIsFieldTypeNumber(fieldType) && (value === '' || checkIsIntegerNumber(value)))
    ) setValue(value);
    if (changeCallback) changeCallback(event);
  }, [setValue, changeCallback, fieldType]);

  const resetValue = useCallback(() => {
    setValue(initValue);
  }, [setValue, initValue]);

  return [value, handlerChangeValue, setValue, resetValue] as const;
};

export default useTextFieldState;
